module.exports = require("@wordpress/api-fetch");